import React from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import { deleteUrlParam, setUrlParam } from "../../../../utils/urlParams";
import useStore, { iProductGroup } from "../store";
import GroupTree from "./GroupTree";
import Search from "./Search";

export const Wrapper = styled.div`
    width: 100%;
    min-width: 240px;
    margin-bottom: 20px;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    ${({ theme }) => theme.breakpoints.from.medium.css`
       position: sticky;
       top: 120px;
       margin-bottom: 0;
    `}
    ${({ theme }) => theme.breakpoints.from.extraLarge.css`
            top: 160px;
    `}
`;

const SideNavigation = () => {
    const [
        productGroups,
        setSelectedProductGroupId,
        setSearch,
        search,
        setPage,
        selectedGroupTree,
        getData,
    ] = useStore(
        (state) => [
            state.productGroups,
            state.setSelectedProductGroupId,
            state.setSearch,
            state.search,
            state.setPage,
            state.selectedGroupTree,
            state.getData,
        ],
        shallow
    );

    const selectGroup = (group: iProductGroup) => {
        setSelectedProductGroupId(group.id);
        setUrl(group);
        setPage(1);
        if (search !== "") {
            setSearch("");
            deleteUrlParam("search");
        }
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        void getData();
    };

    const setUrl = (group: iProductGroup | null) => {
        setUrlParam("group", group ? group.id.toString() : "");
        setUrlParam("page", "1");
    };

    return (
        <Wrapper>
            <Container>
                <Search />
                {productGroups && (
                    <GroupTree
                        selectGroup={selectGroup}
                        selectedProductTree={selectedGroupTree ?? []}
                        productGroups={productGroups}
                    />
                )}
            </Container>
        </Wrapper>
    );
};

export default SideNavigation;
